'use strict';

module.exports.classic = require('./classic');



//////////////////
// WEBPACK FOOTER
// ./src/syntax/index.js
// module id = 11
// module chunks = 0